<div class="input-group">
  <input type="text"
         class="form-control"
         [name]="name"
         [value]="modelDate ? (modelDate | date: (format || 'dd/MM/yyyy')) : ''"
         [required]="required"
         [readOnly]="readonly"
         [disabled]="disabled"
         (focusout)="onInputBlur($any($event.target).value)"
         (keyup.enter)="onInputBlur($any($event.target).value)"
         (click)="!readonly && !disabled && open()" />
  @if (!readonly) {
    <div class="input-group-addon btn btn-auto"
         [class.disabled]="disabled"
         (click)="!disabled && toggle()">
      <i class="fal fa-calendar"></i>
    </div>
  }

  @if (isOpen) {
    <div class="sb-datepicker-popup" (click)="$event.stopPropagation()">
      <div class="sb-datepicker-header">
        <button type="button" class="header-arrow" (click)="prev()" aria-label="Previous">
          <i class="fal fa-chevron-left"></i>
        </button>

        @if (pickerView === 'days') {
          <button type="button" class="header-title" (click)="drillUp()">
            {{ currentMonthKey }} {{ currentYear }}
          </button>
        }
        @if (pickerView === 'months') {
          <button type="button" class="header-title" (click)="drillUp()">
            {{ monthPickerYear }}
          </button>
        }
        @if (pickerView === 'years') {
          <span class="header-title-static">{{ yearGridLabel }}</span>
        }

        <button type="button" class="header-arrow" (click)="next()" aria-label="Next">
          <i class="fal fa-chevron-right"></i>
        </button>
      </div>

      @if (pickerView === 'days') {
        <ngb-datepicker #dp
                        [(ngModel)]="ngbDate"
                        [minDate]="ngbMinDate"
                        [maxDate]="ngbMaxDate"
                        [firstDayOfWeek]="dateOptions.startingDay"
                        [showWeekNumbers]="true"
                        [startDate]="startDate"
                        navigation="none"
                        weekdays="short"
                        (dateSelect)="onDateSelect($event)"
                        (navigate)="onNavigate($event)">
        </ngb-datepicker>
      }

      @if (pickerView === 'months') {
        <div class="sb-datepicker-month-grid">
          @for (m of monthNames; track $index) {
            <button type="button"
                    class="grid-cell"
                    [class.current]="isCurrentMonth($index)"
                    [class.today]="isMonthToday($index)"
                    [disabled]="isMonthDisabled($index)"
                    (click)="selectMonth($index)">
              {{ m }}
            </button>
          }
        </div>
      }

      @if (pickerView === 'years') {
        <div class="sb-datepicker-year-grid">
          @for (y of yearGrid; track y) {
            <button type="button"
                    class="grid-cell"
                    [class.current]="isCurrentYear(y)"
                    [class.today]="isYearToday(y)"
                    [disabled]="isYearDisabled(y)"
                    (click)="selectYear(y)">
              {{ shortYear(y) }}
            </button>
          }
        </div>
      }

      <ng-container *ngTemplateOutlet="footerTpl"></ng-container>
    </div>
  }
</div>

<ng-template #footerTpl>
  <div class="ngb-dp-footer">
    <div>
      <button type="button" class="btn btn-sm btn-info" (click)="setToday()">Today</button>
      <button type="button" class="btn btn-sm btn-danger" (click)="clearDate()">Clear</button>
    </div>
    <button type="button" class="btn btn-sm btn-success" (click)="closePicker()">{{ 'SB_Close' | translate }}</button>
  </div>
</ng-template>
